import { BaseComponent } from 'src/scripts/components/base-component'
import { replaceNodeChildren } from 'src/scripts/utils/dom'
import { $el, whenDefined } from 'src/scripts/utils/utils'

const CART_PAGE_SELECTOR = 'cart-page'
const CART_DRAWER_SELECTOR = 'cart-drawer'
const NEW_COUNT_SELECTOR = '#NewCartCount'

export class CartCount extends BaseComponent {
  cartTargets = new Set<BaseComponent>()

  mountComponent(): void {
    this.bindWhenDefined(CART_PAGE_SELECTOR)
    this.bindWhenDefined(CART_DRAWER_SELECTOR)
  }

  unmountComponent(): void {
    this.cartTargets.forEach(cart => {
      cart.off('update-nodes', this.handleCartUpdate)
    })
    this.cartTargets.clear()
  }

  bindWhenDefined(selector: string): void {
    whenDefined(selector).then(() => {
      if (!this.isConnected) return

      const cart: BaseComponent = $el(selector)
      if (!cart || this.cartTargets.has(cart)) return

      cart.on('update-nodes', this.handleCartUpdate)
      this.cartTargets.add(cart)
    })
  }

  handleCartUpdate = ({ node }): void => {
    const newNode = $el(NEW_COUNT_SELECTOR, node)
    replaceNodeChildren(this, newNode)
  }
}
